import {
  DEFAULT_GRID_PREFERENCE,
  sanitizeGridPreference,
  applyColumnOrder,
  JobsColumnsPopover,
} from '../jobs/JobsColumnsHelper';

export const GRID_PREFERENCES_STORAGE_KEY = 'clientsGridPreferences';

export { DEFAULT_GRID_PREFERENCE, sanitizeGridPreference, applyColumnOrder };
export const ClientsColumnsPopover = JobsColumnsPopover;

/**
 * Parse clients grid preferences as a flat preference object
 * (`{ columnOrder, columnVisibilityModel }`).
 */
export const parseGridPreferences = () => {
  const stored = window.localStorage.getItem(GRID_PREFERENCES_STORAGE_KEY);
  if (!stored) {
    return { ...DEFAULT_GRID_PREFERENCE };
  }

  try {
    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== 'object') {
      return { ...DEFAULT_GRID_PREFERENCE };
    }

    return parsed;
  } catch {
    return { ...DEFAULT_GRID_PREFERENCE };
  }
};
